import { render, staticRenderFns } from "./ModalProductsCategory.vue?vue&type=template&id=9d59e036&scoped=true&"
import script from "./ModalProductsCategory.vue?vue&type=script&lang=js&"
export * from "./ModalProductsCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductsCategory.vue?vue&type=style&index=0&id=9d59e036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d59e036",
  null
  
)

export default component.exports